<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/KLGCC Vertical Gold-01.png">
            </div>

            <!-- <div class="app-name">
                {{ environment.appName }}
            </div> -->

            <div class="title">{{ 'auth.login.title' | translate }}</div>

            <form (ngSubmit)="login()" name="loginForm" [formGroup]="form" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'auth.email' | translate }}</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="form.get('email').hasError('required')">
                        {{ 'auth.email_required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!form.get('email').hasError('required') &&
                    form.get('email').hasError('email')">
                        {{ 'auth.enter_valid_email' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'auth.password' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{ 'auth.password_required' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" aria-label="Remember Me" formControlName="remember_me">
                        {{ 'auth.login.remember_me' | translate }}
                    </mat-checkbox>

                    <a class="forgot-password" [routerLink]="'/auth/forgot-password'">
                        {{ 'auth.login.forgot_password' | translate }}
                    </a>
                </div>

                <!-- <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
                    [disabled]="form.invalid">
                    {{ 'auth.login.login_button' | translate }}
                </button> -->

            </form>

            <div class="register" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-bar-button class="submit-button" (click)="login()" [options]="buttonOption"></mat-bar-button>
            </div>

        </div>

    </div>

</div>